<template lang="pug">
#setChangePassword.tab-pane.fade.show.active(role='tabpanel' aria-labelledby='setChangePassword-tab')
  form
    .mb-3
      label.col-form-label {{ $t('ui.current_password') }}
      input.form-control#oldPassword(type="text" autocomplete="off" maxlength="20" v-model.trim="$v.oldPassword.$model")
      .error.w-100(v-if="$v.oldPassword.$dirty && !$v.oldPassword.required")
        small.text-danger.form-text {{ $t('message.oldpw_required') }}
    .mb-3
      label.col-form-label {{ $t('ui.new_password') }}
      input.form-control(type="text" autocomplete="off" maxlength="20" v-model.trim="$v.newPassword.$model")
      .error.w-100(v-if="$v.newPassword.$dirty && !$v.newPassword.required")
        small.text-danger.form-text {{ $t('message.newpw_required') }}
      .error.w-100(v-else-if="$v.newPassword.$dirty && !$v.newPassword.minLength")
        small.text-danger.form-text {{ $t('message.min_length') }}
      .error.w-100(v-else-if="$v.newPassword.$dirty && !$v.newPassword.isValid")
        small.text-danger.form-text {{ $t('message.newpw_notsame') }}
    .mb-3
      label.col-form-label {{ $t('ui.confirm_password') }}
      input.form-control(type="text" autocomplete="off" maxlength="20" v-model.trim="$v.confirmPassword.$model")
      .error.w-100(v-if="!$v.confirmPassword.sameAsPassword && $v.confirmPassword.$dirty")
        small.text-danger.form-text {{ $t('message.pw_notmatched') }}
    .mt-4.text-center.d-flex.gap-4.justify-content-center
      //- button.btn-cancel(type='button' @click.stop="reset") {{ $t('ui.cancel') }}
      button.btn-submit(type='button' @click.stop="updatePassword") {{ $t('ui.update') }}
</template>
<script>
import config from "@/config"
import errorTags from "@/errorTags";
import { required, minLength, maxLength, sameAs, not } from 'vuelidate/lib/validators'
export default {
  data(){
    return{
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      feedback:{
        success: true,
        status: ""
      }
    }
  },
  validations:{
    oldPassword:{
      required,
    },
    newPassword:{
      required,
      minLength: minLength(6),
      maxLength: maxLength(20),
      isValid : not(sameAs('oldPassword'))
    },
    confirmPassword:{
      required,
      sameAsPassword: sameAs('newPassword')
    }
  },
  computed: {
    getDisplayName() {
      return this.$store.getters.username || this.$store.getters.accountID
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    }
  },
  mounted() {
    // $('#oldPassword').trigger('focus')
  },
  methods:{
    reset() {
      this.oldPassword = ""
      this.newPassword = ""
      this.confirmPassword = ""
      this.feedback.success = true
      this.feedback.status = ""
      this.$v.$reset()
    },
    updatePassword(){
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if(this.sessionToken) {
          let account_id = this.accountID
          let password = this.oldPassword
          let new_password = this.newPassword
          let auth_token = this.sessionToken
          this.loading = true
          this.$store
            .dispatch("user/updatePassword", { account_id, password, new_password, auth_token })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {
                this.reset()
                this.$helpers.showDialog(this.$t("ui.success").toUpperCase(), this.$t("message.change_password_success"), "success", this);
              } else {
                this.feedback.status = this.$t("error." + response.status)
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              this.loading = false
              this.feedback.success = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
              this.feedback.status = this.$t("error." + response.status)
            });
        }
      }
    }
  }
}
</script>
